export class CartPreorderUpdate {
  constructor () {
    // Data
    this.keys = window.theme.preorderUpdateKeys || []
    this.keysData = []

    // Keys
    this.preorderKey = '_preorder'
    this.dispatchDateKey = window?.theme?.strings?.estimated_dispatch

    if (this.keys.length === 0) return

    this.init()
  }

  async init () {
    // Get cart data
    const cart = await window.BAO.Utils.fetchJSON(`/cart.json`, {
      method: 'GET',
    })
    if (!cart) return

    // Retrieve already-existing quantities and properties for the relevant line items
    cart.items.forEach(item => {
      if (this.keys.includes(item.key)) {
        const itemObject = {
          key: item.key,
          quantity: item.quantity,
          properties: item.properties,
        }

        // Delete the preorder properties
        delete itemObject.properties[this.preorderKey]
        delete itemObject.properties[this.dispatchDateKey]

        // Append the line item object data to the keysData array
        this.keysData.push(itemObject)
      }
    })

    // Double check that there's data that needs updating
    if (this.keysData.length === 0) return

    // Create an array of promises by mapping over keysData
    const promises = this.keysData.map(async entry => {
      try {
        const result = await window.BAO.Cart.updateItemProperties(
          entry.key,
          entry.quantity,
          entry.properties,
        )
        return { status: 'fulfilled', value: result }
      } catch (error) {
        return { status: 'rejected', reason: error }
      }
    })

    // Process results
    const results = await Promise.all(promises)
    const errors = results.filter(result => result.status === 'rejected')

    // Report any errors
    if (errors.length > 0) {
      console.error('Cart Preorder Update – Some updates failed:', errors)
    }
  }
}

/* eslint-disable */
document.addEventListener('DOMContentLoaded', () => {
  new CartPreorderUpdate()
})
/* eslint-enable */
